export default class EmailTemplate{
    constructor(id, identifier, template_id, template, from_sender, subject, substitution_fields){
        this.id = id;
        this.identifier = identifier;
        this.template_id = template_id;
        this.template = template;
        this.from_sender = from_sender;
        this.subject = subject;
        this.substitution_fields = substitution_fields || [];
    } 
}